module.exports = __webpack_public_path__ + "img/p2-p2-lubiao.abf8505e.png";